export default class FaqsTabs {
	constructor() {
		// Listen for click on the document
		document.addEventListener("click", function (event) {
			//Bail if our clicked element doesn't have the class
			if (!event.target.classList.contains("faqs__tabs__item__link")) {
				return;
			}

			// -------------------
			// Tabs active items
			// -------------------

			var tabs = document.querySelectorAll(
				".faqs__tabs__item__link.active"
			);
			for (var i = 0; i < tabs.length; i++) {
				tabs[i].classList.remove("active");
			}

			event.target.classList.toggle("active");

			// -------------------
			// Categories show / hide
			// -------------------

			// Get the target content
			var targetHash = event.target.hash;
			var content = document.querySelector(targetHash);
			var categoriesAll = document.querySelectorAll(".faqs__category");
			var faqsTabs = document.querySelector("#faqs-tabs");
			var faqsSelect = document.querySelector("#faqs-select");

			event.preventDefault();

			if (!content) {
				for (var i = 0; i < categoriesAll.length; i++) {
					categoriesAll[i].classList.remove("hide");
					categoriesAll[i].classList.add("show");
				}
			} else {
				for (var i = 0; i < categoriesAll.length; i++) {
					categoriesAll[i].classList.add("hide");
					categoriesAll[i].classList.remove("show");
				}

				// Toggle our content
				content.classList.add("show");
				content.classList.remove("hide");
			}

			faqsTabs.classList.remove("show");
			faqsSelect.classList.remove("show");
			faqsSelect.innerHTML = event.target.innerHTML;
		});
	}
}
